module.exports = __webpack_public_path__ + "media/images/icons/dot-009372aa23921493267570b65a7191ff.svg";